import React from 'react';
import classNames from 'classnames';

import styles from './MediaHeroInfo.module.scss';

const MediaHeroInfo = ({
  title,
  subtitle,
  description,
  eventdataComponent,
  metadataComponent,
  tagsComponent,
  ratingsComponent,
  definitionComponent,
}: {
  title: string;
  subtitle?: string | React.ReactElement | null;
  description?: string | React.ReactElement | null;
  metadataComponent: React.ReactElement | null;
  eventdataComponent?: React.ReactElement | null;
  tagsComponent: React.ReactElement | null;
  ratingsComponent?: React.ReactElement | null;
  definitionComponent: React.ReactElement | null;
}) => {
  return (
    <>
      <h1 className={styles.title}>{title}</h1>
      {eventdataComponent && <div className={styles.eventContainer}>{eventdataComponent}</div>}
      <div className={styles.metaContainer}>
        {ratingsComponent}
        {tagsComponent}
        {metadataComponent}
      </div>
      {!!subtitle && <h2 className={styles.subtitle}>{subtitle}</h2>}
      {description && typeof description === 'string' ? (
        <p className={classNames(styles.description, !!subtitle && styles.smallMarginTop)}>{description}</p>
      ) : (
        description
      )}
      {definitionComponent}
    </>
  );
};

export default MediaHeroInfo;
